import * as Sentry from "@sentry/vue";
import axios from "axios";

const fetchXSRF = (key) => {
  key += "=";
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(key)) {
        cookieValue = decodeURIComponent(cookie.replace(key, ""));
        break;
      }
    }
  }
  return cookieValue;
};

export default function setup() {
  axios.interceptors.request.use(
    (config) => {
      if (config.url.startsWith("/v3/")) {
        config.headers["x-xsrf-token"] = fetchXSRF("xsrf");
      } else {
        config.headers["X-Xsrf-Token"] = fetchXSRF("signup-xsrf");
      }
      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    (config) => {
      localStorage.setItem(config.config.url, JSON.stringify(config.data.data));

      if (!!config.data.data) {
        Sentry.setUser({
          username: `${config.data.data.first_name} ${config.data.data.last_name}`,
          email: config.data.data.email,
          id: config.data.data.signup_id,
        });
      }
      return config;
    },
    (err) => {
      if (err.response.status === 503) {
        window.adspt_intercept();
      }
      return Promise.reject(err);
    }
  );
}
